import React, { createContext } from 'react';
export var DayMapContext = createContext(null);
function DayMapProvider(_a) {
    var children = _a.children, _b = _a.dayMap, dayMap = _b === void 0 ? {} : _b, _c = _a.renderDayFn, renderDayFn = _c === void 0 ? function () { return null; } : _c;
    var context = {
        dayMap: dayMap,
        renderDayFn: renderDayFn,
    };
    return React.createElement(DayMapContext.Provider, { value: context }, children);
}
export default DayMapProvider;
//# sourceMappingURL=DayMapProvider.js.map